import styles from '../../assets/css/accounts.module.css';
import AccountDetails from './AccountDetails';
import IBAN from './IBAN';
import Balance from './Balance';
import IndicatorCircle from './IndicatorCircle';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectPrimaryColor } from '../../app/slices/configuration.slice';
import { Account as AccountType } from '../../types/account';

interface AccountProps {
	account: AccountType;
	isSelected?: boolean;
	onSelect(account: AccountType): void;
}

const Account = ({ account, onSelect, isSelected = false }: AccountProps) => {
	const primaryColor = useSelector(selectPrimaryColor) as string;

	const inlineStyles: React.CSSProperties = {
		border: `1px solid ${primaryColor}`,
		borderLeft: `5px solid ${primaryColor}`,
		boxShadow: '0px 2px 1px -1px #c4c4c4, 0px 1px 1px 0px #c4c4c4, 0px 1px 3px 0px #c4c4c4',
		background: '#ffffff',
		transform: 'scale(1.05)'
	};

	const accountStyles: React.CSSProperties = {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'row',
		boxSizing: 'border-box',
		position: 'relative',
		padding: '10px',
		borderRadius: '10px',
		border: '1px solid rgba(128, 128, 128, 0.37)',
		borderLeft: `5px solid ${primaryColor}`,
		marginTop: '5px',
		marginBottom: '5px'
	};

	return (
		<div
			className={`account ${styles['account']} ${
				isSelected ? `${styles['selected-account']} selected-account` : ''
			}`}
			id={`account-${account.id}`}
			onClick={() => onSelect(account)}
			style={isSelected ? { ...accountStyles, ...inlineStyles } : accountStyles}
		>
			<div className={styles['account-content']}>
				<div className={`${styles['account-details']} ${!account.iban && styles['center-name']}`}>
					<AccountDetails account={account} />
				</div>
				{account.iban && <IBAN iban={account.iban} />}
				<Balance />
			</div>
			<div className={styles['account-select-container']}>
				<IndicatorCircle isActive={isSelected} />
			</div>
			<div className={styles['account-type-mark']}></div>
		</div>
	);
};

export default memo(Account);
